import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {faPlus} from '@fortawesome/free-solid-svg-icons';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {DeviceService} from '../../../../../services/device/device.service';
import {StatesService} from '../../../../../services/state/states.service';
import {Device} from '../../../../../classes/device/device';
import {ToastrService} from 'ngx-toastr';
import {TranslateService} from '@ngx-translate/core';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatTableDataSource} from '@angular/material/table';

@Component({
  selector: 'app-device-children-avalaible',
  templateUrl: './device-children-avalaible.component.html',
  styleUrls: ['./device-children-avalaible.component.css']
})
export class DeviceChildrenAvalaibleComponent implements OnInit {
  public faPlus = faPlus;
  public deviceParent: Device = null;
  public typeChildren: number = null;
  public deviceId = null;
  public deviceTypeName: string = null;
  public showSpinner: boolean = false;
  public currentChannel: number = 0;
  public listChannelAvailableByDeviceType: any[] = [];
  public displayedColumns: string[] = ['type', 'uid', 'action'];
  public childrenAvailable: MatTableDataSource<any>;
  public showSpinnerForChannel: boolean = false;
  public generateLocationPreference = false;

  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(public activeModal: NgbActiveModal,
              private deviceService: DeviceService,
              private statesService: StatesService,
              private toastr: ToastrService,
              private translate: TranslateService) {
  }

  ngOnInit() {
    this.getChildrenAvailable();
  }


  applyFilter(filterValue: string) {
    filterValue = filterValue.trim(); // Remove whitespace
    filterValue = filterValue.toLowerCase(); // Datasource defaults to lowercase matches
    this.childrenAvailable.filter = filterValue;
  }

  setChannel(channel: number) {
    this.currentChannel = channel;
  }

  errorMessage() {
    this.toastr.error(this.translate.instant('NO_CHANNEL_AVAILABLE'), this.translate.instant('ERROR'));
  }

  add(id: number): void {

    //to do patch le devices !! parent et channel a null
    if (this.currentChannel === 0) {
      this.toastr.error(this.translate.instant('SELECT_CHANNEL_REQUIRED'), this.translate.instant('ERROR'));
    } else {
      this.showSpinner = true;
      let device = new Device();
      device.parent = this.deviceId;
      device.channel = this.currentChannel;
      this.deviceService.patchDevice(id, device, this.generateLocationPreference)
        .subscribe(
          (data) => {
            this.getChildrenAvailable();
            this.statesService.reloadProjectDevice.next();
            this.statesService.reloadDeviceCrud.next();
            this.statesService.reloadListDevices.next();
            this.toastr.success(id.toString() + ' added to ' + this.deviceParent.uid, this.translate.instant('SUCCESS'));
            this.showSpinner = false;
            this.currentChannel = 0;
          },
          (error) => {
            this.showSpinner = false;
          }
        );
    }
  }

  private getChildrenAvailable() {
    this.showSpinner = true;
    this.deviceService.getChildrenAvailable(this.deviceParent.device_type).subscribe((data: any) => {
      let childrenAvailable = [];
      data.forEach((d) => {
        if (d.type === this.deviceTypeName) {
          childrenAvailable.push(d);
        }
      });
      this.childrenAvailable = new MatTableDataSource(childrenAvailable);
      this.childrenAvailable.sort = this.sort;
      this.childrenAvailable.paginator = this.paginator;
      this.getListChannelAvailable();
      this.showSpinner = false;

    });
  }

  private getListChannelAvailable() {
    this.showSpinnerForChannel = true;
    let listChannel: number[] = [1, 2, 3, 4, 5, 6];

    if (this.typeChildren === 2 || this.typeChildren === 4) {
      listChannel = [1, 2, 3, 4];
    }

    if (this.typeChildren === 12) {
      listChannel = [1, 2, 3];
    }
    if (this.typeChildren === 3 && this.deviceParent.device_type === 18) {
      listChannel = [1, 2];
    }
    if (this.typeChildren === 16) {
      listChannel = [3];
    }
    this.deviceService.getDevice(this.deviceId)
      .subscribe(
        (data: any) => {
          if (data.children) {
            data.children.forEach(child => {
              if (this.typeChildren === child.device_type.id) {
                let index = listChannel.indexOf(child.channel);
                if (index > -1) {
                  listChannel.splice(index, 1);
                }
              }
            });
          }
          this.listChannelAvailableByDeviceType = listChannel;
          this.showSpinnerForChannel = false;
        },
        error2 => {
          this.showSpinnerForChannel = false;
        });
  }

}
